import React from 'react';
import { useHistory } from 'react-router-dom';

const CommissionPaymentFailure = () => {
    const history = useHistory();

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="min-h-screen bg-light d-flex align-items-center justify-center p-4" style={{ minHeight: '100vh' }}>
                        <div className="card shadow-lg border-0 rounded-lg p-5 text-center" style={{ maxWidth: '450px', width: '100%' }}>

                            {/* Failure Icon (Standard SVG) */}
                            <div className="d-flex justify-content-center mb-4">
                                <div className="bg-danger bg-opacity-10 p-3 rounded-circle" style={{ backgroundColor: '#f8d7da', borderRadius: '50%' }}>
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                </div>
                            </div>

                            <h2 className="fw-bold text-dark mb-2">Payment Failed</h2>
                            <p className="text-muted mb-4">
                                We couldn't process your transaction. This could be due to insufficient funds, a network issue, or an expired session.
                            </p>

                            {/* Action Buttons */}
                            <div className="d-grid gap-2">
                                <button
                                    onClick={() => history.goBack()}
                                    className="btn btn-danger fw-bold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2"
                                >
                                    {/* Refresh Icon SVG */}
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M23 4v6h-6"></path>
                                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                                    </svg>
                                    Try Again
                                </button>

                                <button
                                    onClick={() => history.push('/support')}
                                    className="btn btn-outline-secondary fw-bold py-2"
                                >
                                    Contact Support
                                </button>
                            </div>

                            <p className="mt-4 text-xs text-muted font-italic" style={{ fontSize: '0.8rem' }}>
                                * No funds were deducted from your account.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommissionPaymentFailure;